import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <main className="min-h-[60vh] pt-24 flex items-center justify-center">
      <div className="text-center px-4">
        <div className="w-20 h-20 mx-auto mb-5 flex items-center justify-center rounded-full bg-primary-100">
          <i className="ri-emotion-sad-line text-3xl text-primary-500"></i>
        </div>
        <h1 className="text-2xl font-bold text-foreground-950 font-heading mb-2">
          页面未找到
        </h1>
        <p className="text-sm text-foreground-500 mb-6">
          您访问的页面不存在或已被移除
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
      </div>
    </main>
  );
}